import classNames from 'classnames';
import * as React from 'react';

const ScrollTop = function() {
  const [show, setShow] = React.useState(false);

  const showButton = React.useCallback(() => {
    if (window.scrollY >= window.screen.height / 2) {
      if (!show) {
        setShow(true);
      }
    } else {
      if (show) {
        setShow(false);
      }
    }
  }, [show]);
  const scrollTop  = React.useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();

    scrollTo({
      behavior: 'smooth',
      left:     0,
      top:      0,
    });
  }, []);

  React.useEffect(() => {
    window.addEventListener('scroll', showButton);
    window.addEventListener('resize', showButton);

    return () => {
      window.removeEventListener('scroll', showButton);
      window.removeEventListener('resize', showButton);
    };
  }, [show]);

  return (
    <span
      className={classNames(
        'scrollTop',
        { 'show': show },
      )}
      onClick={scrollTop}
    >&#94;</span>
  );

};

export default ScrollTop;